import { useEffect, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getApiErrorMessage } from '../../services/apiError';
import { getNotificationUsage } from '../../services/api';
import { fmtCurrency } from '../../utils/formatNumber';
import { today } from '../../utils/dateUtils';
import styles from './NotificationUsage.module.css';

const firstOfMonth = () => {
  const d = today(); // YYYY-MM-DD
  return `${d.slice(0, 7)}-01`;
};

const NotificationUsage = () => {
  const [from, setFrom] = useState(firstOfMonth());
  const [to, setTo] = useState(today());
  const [data, setData] = useState({ rows: [], totals: null });
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getNotificationUsage({ from, to });
      setData(res);
    } catch (err) {
      toast.error(getApiErrorMessage(err, 'Failed to load usage'));
    } finally {
      setLoading(false);
    }
  }, [from, to]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="page-header">
        <h2>Notification Usage</h2>
        <p className={styles.subtitle}>Email and WhatsApp messages sent per derasar, with estimated cost.</p>
      </div>

      <div className="filter-bar">
        <div className="form-group">
          <label>From</label>
          <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>
        <div className="form-group">
          <label>To</label>
          <input type="date" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>
        <button className="btn btn-primary" onClick={load} disabled={loading}>Apply</button>
      </div>

      <div className="card">
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Derasar</th>
                <th className={styles.num}>Email (sent / failed)</th>
                <th className={styles.num}>WhatsApp (sent / failed)</th>
                <th className={styles.num}>Est. cost</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={4} className={styles.muted}>Loading…</td></tr>
              ) : data.rows.length === 0 ? (
                <tr><td colSpan={4} className={styles.muted}>No sends in this period.</td></tr>
              ) : data.rows.map((r) => (
                <tr key={r.derasarId}>
                  <td>{r.derasarName}</td>
                  <td className={styles.num}>{r.email.sent} / {r.email.failed}</td>
                  <td className={styles.num}>{r.whatsapp.sent} / {r.whatsapp.failed}</td>
                  <td className={styles.num}>{fmtCurrency(r.estimatedCost)}</td>
                </tr>
              ))}
            </tbody>
            {data.totals && data.rows.length > 0 && (
              <tfoot>
                <tr>
                  <td><strong>Total</strong></td>
                  <td className={styles.num}><strong>{data.totals.email.sent} / {data.totals.email.failed}</strong></td>
                  <td className={styles.num}><strong>{data.totals.whatsapp.sent} / {data.totals.whatsapp.failed}</strong></td>
                  <td className={styles.num}><strong>{fmtCurrency(data.totals.estimatedCost)}</strong></td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>
    </div>
  );
};

export default NotificationUsage;
